export default __webpack_public_path__ + "static/media/iread_22_4.2728bdc2.jpg";